// Service
import ListsService from '../../services/lists.service';
// Reducer
import * as ListsReducer from './lists.reducers';


// Consult Internal Lists ====================================================================================================

export const consultaListasInternas = (data) => async (dispatch) => {
  dispatch(ListsReducer.setConsultInternalListsLoading());

  try {

    const response = await ListsService.consultaListasInternas(data);
    dispatch(ListsReducer.setConsultInternalListsSuccess(response.data?.data));

  } catch(error) {
    if (error.response?.status === 400 && error.response?.data?.data?.codigoError === '1') {
      dispatch(ListsReducer.setConsultInternalListsFailure(error.response?.data?.data));
    } else {
      dispatch(ListsReducer.setConsultInternalListsFailure(error.response?.data?.data?.descripcionError || error.response?.data?.message || error.message));
    }
  }

}

// Clear Consult Internal Lists ====================================================================================================

export const clearConsultaListasInternas = () => async (dispatch) => {
  dispatch(ListsReducer.clearConsultInternalLists());
}

// Consult International Lists ====================================================================================================

export const consultaListasInternacionales = (data) => async (dispatch) => {
  dispatch(ListsReducer.setConsultInternationalListsLoading());

  try {

    const response = await ListsService.consultaListasInternacionales(data);
    dispatch(ListsReducer.setConsultInternationalListsSuccess(response.data?.data));

  } catch(error) {
    if (error.response.status === 400 && error.response?.data?.data?.codigoError === '1') {
      dispatch(ListsReducer.setConsultInternationalListsFailure(error.response?.data?.data));
    } else {
      dispatch(ListsReducer.setConsultInternationalListsFailure(error.response?.data?.data?.descripcionError || error.response?.data?.message || error.message));
    }
  }

}

// Clear Consult International Lists ====================================================================================================

export const clearConsultaListasInternacionales = () => async (dispatch) => {
  dispatch(ListsReducer.clearConsultInternationalLists());
}


// Consult Safe Watch Alert ====================================================================================================

export const consultaAlertaSafeWatch = (data) => async (dispatch) => {
  dispatch(ListsReducer.setConsultSafeWatchAlertLoading());

  try {

    const response = await ListsService.consultaAlertaSafeWatch(data);
    dispatch(ListsReducer.setConsultSafeWatchAlertSuccess(response.data?.data));

  } catch(error) {
    dispatch(ListsReducer.setConsultSafeWatchAlertFailure(error.response?.data?.data || error.message));
  }

}


// Clear Safe Watch Alert ====================================================================================================

export const clearConsultaAlertaSafeWatch = () => async (dispatch) => {
  dispatch(ListsReducer.clearConsultSafeWatchAlert());
}


// Consult Alert Number ====================================================================================================

export const consultaNumeroAlerta = (data) => async (dispatch) => {
  dispatch(ListsReducer.setConsultAlertNumberLoading());

  try {

    const response = await ListsService.consultaNumeroAlerta(data);
    dispatch(ListsReducer.setConsultAlertNumberSuccess(response.data?.data));

  } catch(error) {
    dispatch(ListsReducer.setConsultAlertNumberFailure(error.response?.data?.data || error.message));
  }

}


// Consult Spouse on Lists ====================================================================================================

export const consultarConyugeEnListas = (internalListData, internationalListData) => async (dispatch) => {
  dispatch(ListsReducer.setConsultSpouseOnListsLoading());

  try {

    const response = await ListsService.consultaListasInternas(internalListData);
    if (response.data?.data?.codigoError === "0") {
      const intListResponse = await ListsService.consultaListasInternacionales(internationalListData);

      if (intListResponse?.data?.data?.codigoError === "0") {
        dispatch(ListsReducer.setConsultSpouseOnListsSuccess(intListResponse?.data?.data));
      } else {
        dispatch(ListsReducer.setConsultSpouseOnListsFailure(response.response?.data?.data));
      }
    } else {
      dispatch(ListsReducer.setConsultSpouseOnListsFailure(response.response?.data?.data));
    }


  } catch(error) {
    if (error.response.status === 400 && error.response?.data?.data?.codigoError === '1') {
      dispatch(ListsReducer.setConsultSpouseOnListsFailure(error.response?.data?.data));
    } else {
      dispatch(ListsReducer.setConsultSpouseOnListsFailure(error.response?.data?.message || error.message));
    }
  }
}


// Clear Consult Spouse on Lists ====================================================================================================

export const clearConsultarConyugeEnListas = () => async (dispatch) => {
  dispatch(ListsReducer.clearConsultSpouseOnLists());
}


// Consult Representative on Lists ====================================================================================================

export const consultarApoderadoEnListas = (internalListData, internationalListData) => async (dispatch) => {
  dispatch(ListsReducer.setConsultRepresentativeOnListsLoading());

  try {

    const response = await ListsService.consultaListasInternas(internalListData);

    if (response.data?.data?.codigoError === "0") {
      const intListResponse = await ListsService.consultaListasInternacionales(internationalListData);

      if (intListResponse?.data?.data?.codigoError === "0") {
        dispatch(ListsReducer.setConsultRepresentativeOnListsSuccess(intListResponse?.data?.data));
      } else {
        dispatch(ListsReducer.setConsultRepresentativeOnListsFailure(response.response?.data?.data));
      }
    } else {
      dispatch(ListsReducer.setConsultRepresentativeOnListsFailure(response.response?.data?.data));
    }


  } catch(error) {
    if (error.response.status === 400 && error.response?.data?.data?.codigoError === '1') {
      dispatch(ListsReducer.setConsultRepresentativeOnListsFailure(error.response?.data?.data));
    } else {
      dispatch(ListsReducer.setConsultRepresentativeOnListsFailure(error.response?.data?.message || error.message));
    }
  }
}


// Clear Consult Representative on Lists ====================================================================================================

export const clearConsultarApoderadoEnListas = () => async (dispatch) => {
  dispatch(ListsReducer.clearConsultRepresentativeOnLists());
}

// Insert Client On List For Review ====================================================================================================

export const insertarClienteEnListaParaRevision = (data) => async (dispatch) => {
  dispatch(ListsReducer.setInsertClientOnListForReviewLoading());

  try {

    const response = await ListsService.insertarClienteEnListaParaRevision(data);
    dispatch(ListsReducer.setInsertClientOnListForReviewSuccess(response.data));

  } catch(error) {
    dispatch(ListsReducer.setInsertClientOnListForReviewFailure(error.response?.data?.data || error.message));
  }

}

// Clear Insert Client On List For Review ====================================================================================================

export const clearInsertarClienteEnListaParaRevision = () => async (dispatch) => {
  dispatch(ListsReducer.clearInsertClientOnListForReview());
}